module.exports = __webpack_public_path__ + "img/CS-Profi13_Overview-Spare_3.8d2e19f2.jpg";